class CitiesTabFilter {
    constructor(element) {
        this.element = element
        this.tabs = $(this.element).find('.js-cities-tabs')[0]._tabs
        this.citiesList = $(this.element).find('.js-cities-list')
        this.tabs.tabContent = this.element
        this.initListeners()
    }

    initListeners() {
        $(this.element).on('tab:change', this.changeActiveCities.bind(this))
    }

    changeActiveCities() {
        this.alphabetItems.hide()
        this.filteredCities.length ? this.filteredCities.show() : this.alphabetItems.show()
    }

    get filteredCities() {
        return this.alphabetItems.filter((index, item) => {
            const citiesFirstLetter = $(item).find('.js-alphabet-letter').text()
            const tabLetter = this.tabs.activeTab.val()
            return citiesFirstLetter.toLowerCase() === tabLetter.toLowerCase()
        })
    }

    get alphabetItems() {
        return $(this.citiesList).find('.js-alphabet-item')
    }
}

$('.js-cities-tab-filter').each((index, item) => {
    new CitiesTabFilter(item)
})
